module.exports = __webpack_public_path__ + "static/img/img_intro_bid.69c4398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_intro_bid.png
// module id = R9Q+
// module chunks = 1